import { Location } from 'history';
import State from '../core/State';

const setLocation = (location: Location) => (state: State): State => ({
  ...state,
  location: {
    pathname: location.pathname,
    search: location.search,
  },
});

export default setLocation;
